
    import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import User from '../../../store/entities/user'
    @Component
    export default class ChangePassword extends AbpBase{
        @Prop({type:Boolean,default:false}) value:boolean;
        // olduser:User=new User();
        user:any={
            currentPassword:'',
            newPassword:'',
        }
        created(){
            console.log(this.user)
        }
        get roles(){
            return this.$store.state.user.roles;
        }
        save(){
            (this.$refs.userForm as any).validate(async (valid:boolean)=>{
                if(valid){
                    await this.$store.dispatch({
                        type:'user/changePassword',
                        data:this.user
                    });
                    (this.$refs.userForm as any).resetFields();
                    this.$emit('save-success');
                    this.$emit('input',false);
                }
            })
        }
        cancel(){
            (this.$refs.userForm as any).resetFields();
            this.$emit('input',false);
        }
        visibleChange(value:boolean){
            if(!value){
                this.$emit('input',value);
            }else{
                this.user=Util.extend(true,{},this.$store.state.user.editUser);
            }
        }
        userRule={
            currentPassword:[{required:true,message:this.L('请输入原密码',undefined,this.L('原密码')),trigger: 'blur'}],
            newPassword:[{required:true,message:this.L('请输入新密码',undefined,this.L('新密码')),trigger: 'blur'}],
        }
    }
